import React, {Component} from 'react';
import {ListGroup, ListGroupItem} from 'reactstrap';
import firebase from "../../Config/firebase";
import Post from "../../Component/PostList/Post/Post"

import classes from '../../Component/PostList/PostList.module.css'
import {MDBAlert} from "mdbreact";

const db = firebase.firestore()

class HotPostList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            isGettingPostList:false,
            noMorePost:false,
            posts: []
        }

    }

    componentDidMount() {
        this.getMyPost()

        window.onscroll = function () {
            if (!this.state.noMorePost && window.location.pathname === '/newest') {
                if (window.scrollY + window.outerHeight >= document.getElementById("scrollDetect").offsetTop && this.state.isLoaded) {
                    if (!this.state.isGettingPostList) {
                        this.setState({
                            isGettingPostList: true
                        }, async () => {
                            const getState = await this.getNextPost(this.state.posts[this.state.posts.length - 1].createDate)
                            if (getState.success) {
                                this.setState({
                                    isGettingPostList: false
                                })
                            }
                        })
                    }

                }
            }
        }.bind(this);
    }

    getMyPost = () => {
        db.collection('Post')
            .limit(8)
            .where('isPublish', '==', true)
            .orderBy('netCount', 'desc')
            .get()
            .then(docs => {
                if (!docs.empty) {
                    let allPost = []
                    docs.forEach(function (doc) {
                        const post = {
                            id: doc.id,
                            ...doc.data()
                        }
                        allPost.push(post)
                    })
                    this.setState({
                        posts: allPost
                    }, () => {
                        this.setState({
                            isLoaded: true
                        })
                    })
                }

            })
    }

    getNextPost = (data) => {
        console.log('getting next')
        console.log(data)
        return new Promise((resolve, reject) => {
            db.collection('Post')
                .limit(8)
                .where('isPublish', '==', true)
                .orderBy('netCount', 'desc')
                .startAfter(data)
                .get()
                .then(docs => {
                    if (!docs.empty) {
                        let allPost = []
                        docs.forEach(function (doc) {
                            const post = {
                                id: doc.id,
                                ...doc.data()
                            }
                            allPost.push(post)
                        })
                        this.setState({
                            posts: this.state.posts.concat(allPost)
                        }, () => {
                            this.setState({
                                isLoaded: true
                            }, () => {
                                resolve({success:true})
                            })
                        })
                    }
                    else{
                        this.setState({
                            noMorePost:true
                        }, () => {
                            resolve({success:true})
                        })
                    }

                })
        })

    }

    render() {
        return (
            <div>
                <ListGroup flush>
                    {
                        this.state.isLoaded ?
                            this.state.posts.map((post, index) => {
                                return (
                                    <Post
                                        key={index}
                                        data={post}
                                    />
                                )
                            })
                            : ''
                    }
                </ListGroup>

                {
                    !this.state.noMorePost ?
                        <div id='scrollDetect'  className={classes.ScrollDetect}>
                            {
                                this.state.isLoaded ?
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                    : ''
                            }
                        </div> :
                        <MDBAlert color='light' className={classes.NoMoreElement}>
                            沒有找到更多的貼文
                        </MDBAlert>
                }
            </div>

        );
    }
}

export default HotPostList;